module.exports = __webpack_public_path__ + "img/ec.643ab43c.svg";